import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import { getStandards } from 'helpers/standards';
import MetricConversions from 'libs/MetricConversions';
import App from 'modules/App';
import Account from 'modules/Account';
import * as selectors from 'modules/PatientResults/selectors';
import { getIsPlainValuesMode, getMaxPlainValue } from '../helpers';
const prepareScaleValues = (trendData, minStdValue, maxStdValue, metricsUnits, isPlainValuesMode)=>{
    const { maxReadingValue } = trendData;
    const metricConversions = new MetricConversions(metricsUnits);
    const conversion = metricConversions.bloodGlucoseConcentration;
    let step = 5;
    if (isPlainValuesMode) {
        step = 10;
    } else if (conversion.unit === 'MG_DL') {
        step = 50;
    }
    const maxScaleValue = Math.max(maxStdValue, Math.ceil(maxReadingValue / step) * step);
    const scaleValues = [
        minStdValue
    ];
    let valueTick = step;
    while(valueTick <= maxScaleValue){
        scaleValues.push(valueTick);
        valueTick += step;
    }
    return {
        scaleValues,
        minScaleValue: minStdValue,
        maxScaleValue
    };
};
export const useScaleValues = (trendData)=>{
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const clinicSettings = useSelector(profileContext.selectors.clinicSettings);
    const calculationFormula = useSelector(selectors.calculationFormula);
    const countrySettings = useSelector(App.selectors.countrySettings);
    const metricsUnits = useSelector(Account.selectors.metricsUnits);
    const metricConversions = new MetricConversions(metricsUnits);
    const conversion = metricConversions.bloodGlucoseConcentration;
    const standards = getStandards(phiSet, countrySettings, clinicSettings);
    const isPlainValuesMode = getIsPlainValuesMode(calculationFormula);
    const { minStdValue, maxStdValue } = useMemo(()=>{
        const maxPlainValue = getMaxPlainValue(calculationFormula);
        return {
            minStdValue: isPlainValuesMode ? 0 : conversion.toDisplay(standards.minValue, 1),
            maxStdValue: isPlainValuesMode ? maxPlainValue : Math.ceil(conversion.toDisplay(standards.maxValue))
        };
    }, [
        phiSet,
        calculationFormula
    ]);
    return useMemo(()=>prepareScaleValues(trendData, minStdValue, maxStdValue, metricsUnits, isPlainValuesMode), [
        trendData,
        phiSet,
        isPlainValuesMode
    ]);
};
